import { AppState, AppStateStatus } from 'react-native';

export type AppStateHandlerType = (appState: AppStateStatus) => void;

export class AppStateService {
  readonly appStates = {
    ACTIVE: 'active',
    BACKGROUND: 'background',
    INACTIVE: 'inactive',
  };

  private _listeners: AppStateHandlerType[];

  constructor() {
    this._listeners = [];

    this._handler = this._handler.bind(this);
  }

  init(): void {
    AppState.addEventListener('change', this._handler);
  }

  get appCurrentState(): AppStateStatus {
    return AppState.currentState;
  }

  get isActive(): boolean {
    return this.appCurrentState === this.appStates.ACTIVE;
  }

  get isBackground(): boolean {
    return this.appCurrentState === this.appStates.BACKGROUND;
  }

  get isInactive(): boolean {
    return this.appCurrentState === this.appStates.INACTIVE;
  }

  private async _handler(): Promise<void> {
    // call all registered listeners
    this._listeners.forEach((cb) => {
      cb(this.appCurrentState);
    });
  }

  addChangeListener(handler: AppStateHandlerType): void {
    this._listeners.push(handler);
  }

  removeChangeListener(handler: AppStateHandlerType): void {
    this._listeners = this._listeners.filter((i) => i !== handler);
  }
}

export default new AppStateService();
